export function DebugSection({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <div className="p-4">
      <div className="mb-3 space-y-1">
        <label className="block text-sm font-bold uppercase text-primary">{title}</label>
        {subtitle && <label className="text-muted-foreground block text-sm">{subtitle}</label>}
      </div>
      {children}
    </div>
  );
}
